import { FC, SyntheticEvent, useRef } from 'react';
import styles from './modalOverlay.module.css';

export const ModalOverlay: FC = () => {
    
    const overlayRef = useRef(null)


    return (
        <div className={styles.overlay}
            ref={overlayRef}>
        </div>
    )
}